/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorContentLock as ResolvedLabradorContentLock } from 'base/components/labrador/ContentLock';

export const LabradorContentLock: typeof ResolvedLabradorContentLock = withLabradorInstanceof((props) => {
    return <ResolvedLabradorContentLock {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorContentLockProps = PropsFromComponent<typeof LabradorContentLock>;
